import { useQuery } from "react-query";
import { zodParseWithDetailedLog } from "src/api/apiErrorLogs";
import { loggedInApiCall } from "src/api/axiosClient/userApi";
import { OlapScoresQuery } from "src/context/OlapScores/useOlapScoresParams";
import { OlapScoresWithPrevScoresSchema } from "./olapScoresSchema";

export const getOrganizationScoresKey = "getCompanyScores" as const;

type Options = {
    companyId: number | undefined;
    ssqId: number | undefined;
    campaignId: number | undefined;
    scoresQuery?: OlapScoresQuery;
};

export const useGetOrganizationScores = (options: Options) => {
    const { companyId, ssqId, campaignId, scoresQuery } = options;

    return useQuery({
        queryKey: [getOrganizationScoresKey, companyId, ssqId, campaignId, scoresQuery],
        enabled: companyId !== undefined && ssqId !== undefined && campaignId !== undefined,
        staleTime: 5 * 60 * 1000,
        queryFn: async () => {
            const url = `/api/organizations/${companyId}/ssq/${ssqId}/campaign/${campaignId}/scores`;

            return await loggedInApiCall.get(url, {
                params: scoresQuery,
            });
        },
        select: (request) => {
            const data = zodParseWithDetailedLog(request.data, OlapScoresWithPrevScoresSchema, {
                operation: "GET",
                endpoint: "/organizations/:id/ssq/:ssqId/campaign/:campaignId/scores",
            });
            return data;
        },
    });
};
